import React from "react";

const TestimonialsComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default TestimonialsComponent;
